module.exports = __webpack_public_path__ + "static/media/swimmy-app-logo.810aee9a.png";